import { enumValue } from './enums';

export interface ProviderSpecialtyType {
    id: number;
    name: string;
    isPrimary: boolean;
}
export interface HubTagType {
    id: number;
    name: string;
}
export interface ProviderType {
    id: number;
    active: boolean;
    entityType: number;
    npi: null | string;
    practiceName?: undefined | string;
    orgName?: undefined | string;
    orgId?: undefined | number;
    planOwningOrg: number;
    firstName?: null | string;
    lastName?: null | string;
    suffix?: null | string;
    specialties?: undefined | ProviderSpecialtyType[];
    hubTags: HubTagType[];
    phones?: undefined | PhoneType[];
    status?: undefined | number;
    locations?: LocationType[];
    organization?: {
        id: number;
        name: string;
        phones: PhoneType[];
        invitation?: { active: boolean };
    };
    addresses?: AddressType[];
    invitation?: { active: boolean };
}

export enum ProviderEntityEnum {
    ORG = 1,
    CONTACT = 2,
    PHYSICIAN = 3,
}
export function getProviderInfo(provider: ProviderType) {
    const providerName =
        provider.entityType === ProviderEntityEnum.ORG
            ? 'Any Provider'
            : `${provider?.lastName ? provider.lastName : ''}${
                  provider?.suffix ? ` ${provider.suffix}` : ''
              }${provider?.firstName ? `, ${provider.firstName}` : ''}`;
    let providerFax =
        provider.entityType === ProviderEntityEnum.CONTACT &&
        provider.phones &&
        provider.phones.find(
            (phone) => phone.type === enumValue(['core_app', 'phone_types', 'Practice Fax'])
        );
    if (!providerFax) providerFax = undefined;
    const providerPhone = provider.phones?.find(
        (phone) => phone.type === enumValue(['core_app', 'phone_types', 'Practice'])
    );
    const providerIsContact = provider.entityType === ProviderEntityEnum.CONTACT;
    return { providerName, providerFax, providerPhone, providerIsContact };
}

export enum TierEnum {
    PREMIER = 'Premier',
    TIER_1 = 'Tier 1',
    TIER_2 = 'Tier 2',
    NO_TIER_INFO = 'No Tier Info',
    NULL_TIER = '\u00A0',
}

interface TierData {
    tier: number;
    tierName: string;
    tierClasses: string;
}
export function getProviderTier(acc: TierData, current: HubTagType) {
    if (current.name === TierEnum.PREMIER)
        return {
            tier: 4,
            tierName: TierEnum.PREMIER,
            tierClasses: 'bg-info text-light',
        };
    if (current.name === TierEnum.TIER_1 && acc.tier < 3)
        return { tier: 3, tierName: TierEnum.TIER_1, tierClasses: 'bg-success text-light' };
    if (current.name === TierEnum.TIER_2 && acc.tier < 2)
        return {
            tier: 2,
            tierName: TierEnum.TIER_2,
            tierClasses: 'bg-secondary text-light',
        };
    if (current.name === TierEnum.NO_TIER_INFO && acc.tier < 1)
        return { tier: 2, tierName: TierEnum.NO_TIER_INFO, tierClasses: '' };
    return acc;
}

export function mapProviderResults(results: TODO_TYPEME) {
    return results.map((x: TODO_TYPEME) => ({
        id: x.id,
        active: x.active,
        entityType: x.entity_type,
        npi: x.npi,
        orgName: x.entity_type === 1 ? x?.name : x?.organization?.name,
        orgId: x.entity_type === 1 ? x?.id : x?.organization?.id,
        planOwningOrg: x?.plan_owning_org_id,
        practiceName: x?.practice_name,
        firstName: x?.first_name,
        lastName: x?.last_name,
        suffix: x?.name_suffix,
        specialties: x?.specializations.map((y: TODO_TYPEME) => ({
            id: y.nucc_id,
            name: y.display_name,
            isPrimary: y.is_primary,
        })),
        hubTags: x.hub_tags,
        phones: x.phones,
        status: x.status,
        locations: x.locations,
        organization: x.organization,
        addresses: x.addresses,
        invitation: x.invitation,
    }));
}
